import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import './Loader.scss';

const Loader = ({ message }) => {
  const [direction, setDirection] = useState('add');
  const [percent, setPercent] = useState(-100);

  const [defaultColor, loaderColor] = useMemo(() => {
    const styles = getComputedStyle(document.documentElement);

    return [styles.getPropertyValue('--loader-default-bg'), styles.getPropertyValue('--loader-default-loading-bg')];
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercent((seconds) => {
        if (direction === 'add') return seconds + 20;
        return seconds - 20;
      });

      if (direction === 'add' && percent === 100) setDirection('decrease');
      if (direction === 'decrease' && percent === -100) setDirection('add');
    }, 100);
    return () => clearInterval(interval);
  }, [percent, direction]);

  return (
    <div className="loader-wrapper">
      <div
        className="loader-bg"
        style={{
          background: `linear-gradient(-360deg, ${loaderColor} ${percent}%, ${defaultColor} 100%)`,
        }}
      />
      <div className="loader-message">{message}</div>
    </div>
  );
};

Loader.defaultProps = { message: '' };

Loader.propTypes = { message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]) };

export default Loader;
